import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { PlusCircleOutlined } from '@ant-design/icons';
import HelpLabel from "../../components/HelpLabel";
const CustomerLabelWithHelpPopover = () => {
    return (_jsx(HelpLabel, { title: "Customer", helpText: _jsxs("p", { children: ["By selecting the ", _jsx(PlusCircleOutlined, {}), " you can add your customer name and an optional proof of delivery (POD) email address. By having a customer selected here they can receive an email when their delivery is completed with a PDF copy of their POD."] }) }));
};
export default CustomerLabelWithHelpPopover;
